import * as React from "react";

function SvgEnjoyHq(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <linearGradient
        id="EnjoyHQ_svg__a"
        gradientUnits="userSpaceOnUse"
        x1={0}
        y1={19}
        x2={39.35}
        y2={19}
      >
        <stop offset={0} stopColor="#6848b4" />
        <stop offset={1} stopColor="#506cf0" />
      </linearGradient>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="url(#EnjoyHQ_svg__a)"
        d="M22.71 8.58c.84.54 1.39 1.45 1.39 2.46 0 1.22-.77 2.26-1.89 2.74a3.88 3.88 0 001.28-2.88c0-.87-.29-1.67-.78-2.32zM0 19.78C0 8.86 8.81 0 19.67 0c10.87 0 19.68 8.86 19.68 19.78 0 6.66-3.28 12.55-8.3 16.14 2.44.54 4.57 1.25 6.25 2.08h-.42c-3.55-.79-7.69-1.34-12.19-1.57.62-.49 1.05-1.21.99-1.98.22-4.94-1.7-7.55-1.46-9.37.38-.29.65-.71.81-1.22.25.47.83 1.15.83 1.15l.34.65c.31.24.24-.29.33-.3 1.23.68 2.58-1.44.61-2.2-.13-2.18-.85-3.06-1.34-3.62.73-3.96.08-5.9-1.23-6.27-.84 1.11-1.17.52-.9.11-.08.05-.16.1-.25.15-.59.48-1.36.78-2.21.78-1.85 0-3.34-1.4-3.34-3.12 0-1.73 1.49-3.13 3.34-3.13.91 0 1.74.35 2.35.91-.7-.94-1.8-1.54-3.05-1.54-2.1 0-3.81 1.71-3.81 3.82 0 .73.2 1.41.55 1.99l-2.59.01-.32-2.87c-.09-.77-.24-1.35-.43-1.76l-.67-1.63c-.97 0 0 1.01-.19 1.25-.48.58-1.44-.07-.83 1.81l-.47.28c-.27 4.64.54 5.6.54 5.6l3.48 1.57.8 4.32c-1.52.78-3.96 3.01-4.18 4.91l1.12 4.94c-.69 1.5-1.49 1.9-1.05 2.66.36.9 1.22 1.21 2.11 1l2.14-2.17c.92-.62-.42-3.77-.64-5.68.63-.48 1.13-.38 3.09-1.35 2.48 1.99 1.34 6.5 2.77 8l-.52 1.76c.04.16.1.3.16.42-.63-.01-1.26-.01-1.9-.01-6.42 0-12.37.63-17.2 1.7h-.43c1.69-.83 3.81-1.54 6.25-2.08A19.796 19.796 0 010 19.78zm29.03-5.22c1.34 0 2.42 1.09 2.42 2.43 0-1.34 1.08-2.43 2.41-2.43-1.33 0-2.41-1.09-2.41-2.43 0 1.34-1.08 2.43-2.42 2.43zM3.7 16.53c.87 0 1.57.71 1.57 1.58 0-.87.71-1.58 1.57-1.58-.86 0-1.57-.71-1.57-1.58 0 .87-.7 1.58-1.57 1.58zm26.37 12.76c.32 0 .59.26.59.59 0-.33.26-.59.58-.59-.32 0-.58-.26-.58-.59 0 .33-.27.59-.59.59z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgEnjoyHq);
